<div *ngIf="mode === 'cancel'" class="mb-3">
  <app-model [controlConfig]="{type: 'dropdown-multi', title: 'sticker.type', label: 'sticker.type'}" [options]="listStickerType"
             [value]="type" (modelValueChange)="type = $event"></app-model>
</div>
<div>
  <label>{{'file.label' | translate}} <span class="text-required">*</span></label>
  <div>
    <image-upload [imageSrc]="url" [label]="'file.title'" [idImg]="'id' + mode" [type]="'Excel'" [showSupport]="true" [canUpload]="false"
                  (onUpload)="handleFileUpload($event)" [size]="'medium'" [max]="20"></image-upload>
  </div>
</div>
<div class="mt-3">
  <a href="javascript:void(0)" class="template" (click)="downloadTemplate()">
    {{'file.down-template' | translate}} <lucide-icon [size]="14" [name]="'arrow-down-to-line'"></lucide-icon></a>
</div>
<div *nzModalTitle class="title-modal">{{ 'sticker.modal-title' | translate: {modeVal: ('sticker.' + mode | translate)} }}</div>
<div *nzModalFooter>
  <ng-container>
    <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{ 'cancel' | translate }}</button>
        <button nz-button nzType="primary" [disabled]="!file" (click)="onSave()">{{ 'save' | translate }}</button>
  </ng-container>
</div>